export default "The result is a blurry composite of all the colors in the scene, a meaningless image\n\nWell, there is a solution (build up to next slide)\n"